// Angular
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
// Theming
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTreeModule } from "@angular/material/tree";
import {
  LoaderDisablesFormGroupModule,
  LoaderTogglesClassModule,
} from "@orthofi/ngx-loader";
// Components
import { InlineNotificationComponent } from "./components/inline-notification/inline-notification.component";
import { ToggleableVisibilityDirective } from "./directives/toggleableVisibility.directive";
import { CurrencyInputDirective } from "./directives/currency-input.directive";
import { IntegerInputDirective } from "./directives/integer-input.directive";
import { DebounceDirective } from "./directives/debounce.directive";

// import { LoaderTogglesClassModule } from '@orthofi/ngx-loader/lib/directives/loader-toggles-class/loader-toggles-class.module';

/**
 * The `SharedModule` is imported in to any feature module where it's children are needed. And, those children are almost
 * always a **dumb** components, directives, and pipes. Generally, `SharedModule` is not imported in to the `AppModule` or `CoreModule`,
 * if you're considering importing the `SharedModule` there to access a child, and the child is single-use, perhaps that child should
 * be moved in to the `CoreModule`.
 *
 * A shared module that needs to be added to a lazy loaded module should **not** have providers, because that would create duplicate
 * service instances. (You could have providers, if duplicate services are intended).
 */
@NgModule({
  declarations: [
    InlineNotificationComponent,
    ToggleableVisibilityDirective,
    CurrencyInputDirective,
    IntegerInputDirective,
    DebounceDirective,
  ],
  imports: [
    // Angular
    CommonModule,
    // Other
    LoaderDisablesFormGroupModule,
    LoaderTogglesClassModule,
  ],
  exports: [
    InlineNotificationComponent,
    ToggleableVisibilityDirective,
    CurrencyInputDirective,
    IntegerInputDirective,
    DebounceDirective,
    // Angular
    CommonModule,
    FlexLayoutModule,
    // App wide Material modules. If a feature module needs a new one, but it's not needed app wide, import it in the feature.
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatToolbarModule,
    MatMenuModule,
    MatTabsModule,
    MatExpansionModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatTableModule,
    MatTreeModule,
    MatDialogModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatGridListModule,
    // Loader library directives
    LoaderDisablesFormGroupModule,
    LoaderTogglesClassModule,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class SharedModule {} // Don't think about using ModuleWithProviders here until you read this module's docs.
